import { render, staticRenderFns } from "./ExtratoPF.vue?vue&type=template&id=38d36804"
import script from "./ExtratoPF.vue?vue&type=script&lang=js"
export * from "./ExtratoPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports